import { putMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_UPDATE_STATUS = 'GET_UPDATE_STATUS';
export const GET_UPDATE_STATUS_SUCCESS = 'GET_UPDATE_STATUS_SUCCESS';
export const GET_UPDATE_STATUS_FAILURE = 'GET_UPDATE_STATUS_FAILURE';

// Action Creators
export const getUpdateStatus = () => ({
  type: GET_UPDATE_STATUS,
});

export const getUpdateStatusSuccess = (users) => ({
  type: GET_UPDATE_STATUS_SUCCESS,
  payload: users,
});

export const getUpdateStatusFailure = (error) => ({
  type: GET_UPDATE_STATUS_FAILURE,
  payload: error,
});

// Thunk Function
export const getUpdateStatusValue = (external, id, body, data = '') => {
  return async (dispatch) => {
    dispatch(getUpdateStatus());
    try {
      const response = await putMethodWithToken(
        url?.updateStatus + id + '/' + data,
        body
      );
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getUpdateStatusSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getUpdateStatusFailure(error?.message));
    }
  };
};
